export default function HowItWorksSection() {
  const steps = [
    {
      icon: "ri-file-search-line",
      title: "Expert Document Review",
      description: "Specialists check every document before submission. Errors cause rejections adding weeks to your timeline. We catch them first.",
    },
    {
      icon: "ri-hand-heart-line",
      title: "Hand-Courier Submission",
      description: "Our couriers physically deliver your application to the passport agency using reserved daily slots not available to the public. Same-day submission guaranteed.",
    },
    {
      icon: "ri-building-2-line",
      title: "Agency Processing",
      description: "The State Dept. processes your application in 3, 4, 7, or 9 business days depending on your tier. Reserved slots mean same-day submission — no mail queue.",
    },
    {
      icon: "ri-truck-line",
      title: "Overnight Return Delivery",
      description: "Your passport ships back via overnight FedEx the moment the agency releases it. Real-time tracking throughout.",
    },
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          What a Passport Expediting Service Does For You
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-14 text-base md:text-lg">
          Four steps from your application to your passport — handled by a registered courier with daily agency access.
        </p>

        <div className="max-w-4xl mx-auto relative">
          <div className="hidden md:block absolute left-[27px] top-10 bottom-10 w-0.5 bg-[#D0D7E2]"></div>
          <div className="space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col md:flex-row gap-5 md:gap-8 relative">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#1A365D] flex items-center justify-center z-10">
                  <i className={`${step.icon} text-2xl text-[#C0C8D6]`}></i>
                </div>
                <div className="flex-1 pt-2">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#4A7AB5] mb-1">Step {i + 1}</div>
                  <h3 className="font-bold text-xl text-[#1A365D] mb-2">{step.title}</h3>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}